import * as color from '../sass/color.scss';

/**
 * List of supported Order Status'
 */
export const statusList = [
  {
    name: 'Live',
    value: 'live',
    tagStyle: {
      background: color.success16,
      color: color.success,
    },
  },
  {
    name: 'Completed',
    value: 'completed',
    tagStyle: {
      background: color.primary16,
      color: color.primary,
    },
  },
  {
    name: 'Pending',
    value: 'pending',
    tagStyle: {
      background: color.yellow16,
      color: color.yellow,
    },
  },
  {
    name: 'Paused',
    value: 'paused',
    tagStyle: {
      background: color.error16,
      color: color.error,
    },
  },
  {
    name: 'Cancelled',
    value: 'cancelled',
    tagStyle: {
      background: color.manatee16,
      color: color.manatee,
    },
  },
];

export default {
  statusList,
};
